import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {BookingPrice, Price} from '../models/price';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  constructor(private http: HttpClient) {
  }

  findPrices(productIds: string[], referralIds: string[], promotionIds: string[]) {
    const params = {productIds, referralIds, promotionIds};
    return this.http.get<Price>(`${API}/api/prices`, {params});
  }

  findPricesByUser(userId: string, productIds: string[], referralIds: string[], promotionIds: string[]) {
    const params = {userId: userId, productIds, referralIds, promotionIds};
    return this.http.get<Price>(`${API}/api/prices`, {params});
  }

  findBookingPrices(productIds: string[], referralIds: string[], promotionIds: string[], roomId: string, localBegin: string, localEnd: string) {
    const params = {productIds, referralIds, promotionIds, roomId, localBegin, localEnd};
    return this.http.get<BookingPrice>(`${API}/api/prices/booking`, {params});
  }

  findBookingPricesByUser(userId: string, productIds: string[], referralIds: string[], promotionIds: string[]) {
    const params = {userId: userId, productIds, referralIds, promotionIds};
    return this.http.get<BookingPrice>(`${API}/api/prices/booking`, {params});
  }
}
